module.exports = __webpack_public_path__ + "static/media/rina-2.d070d660.jpg";